<template>
  <div style="padding: 24px;background: #fff;">
    <date-paginator
      @selectItemHandle="selectItemHandle"
      @prevDateHandle="selectItemHandle"
      @nextDateHandle="selectItemHandle"
      :currentDate="currentDate"
      :publishhDateState="publishhDateState"
    ></date-paginator>
    <!-- 菜品发布列表--早中晚 -->
    <div class="menu-publish-content">
      <a-collapse v-model="activeKey" style="margin-top:10px;">
        <a-collapse-panel :key="item.key" v-for="item in publishMenuList">
          <template slot="header">
            {{ item.title }}
            <template v-if="actionBtnShow">
              <a
                href="javascript:void(0)"
                class="slot-publish-href"
                @click.stop="publishMenuShow(item, 'add')"
                title="发布菜品"
                v-if="item.list.length === 0"
                >发布</a
              >
              <a
                href="javascript:void(0)"
                class="slot-publish-href"
                @click.stop="publishMenuShow(item, 'edit')"
                title="编辑菜品"
                v-else
                >编辑</a
              >
            </template>
          </template>
          <div>
            <a-spin :spinning="listItemLoading"></a-spin>

            <a-list
              class="publishMenuListContent"
              :grid="{ gutter: 16, column: 6 }"
              :dataSource="item.list"
            >
              <a-list-item slot="renderItem" slot-scope="c_item">
                <a-card hoverable style="width:100%;">
                  <div class="itemImgContent" v-if="c_item.isPackage">
                    <img
                      v-for="(g_c_item, g_c_index) in c_item.menus.length > 4
                        ? c_item.menus.slice(0, 4)
                        : c_item.menus"
                      :key="g_c_item.id"
                      :alt="g_c_item.name"
                      :title="g_c_item.name"
                      :style="getImgStyle(g_c_item, g_c_index, c_item)"
                      :src="
                        g_c_item.imgUrl ? g_c_item.imgUrl : 'images/noImg.jpg'
                      "
                      onerror="this.src='images/noImg.jpg'"
                      slot="cover"
                    />
                  </div>
                  <div class="itemImgContent" v-else>
                    <img
                      :alt="c_item.name"
                      :title="c_item.name"
                      style="width:100%;"
                      :src="c_item.imgUrl ? c_item.imgUrl : 'images/noImg.jpg'"
                      onerror="this.src='images/noImg.jpg'"
                      slot="cover"
                    />
                  </div>

                  <a-card-meta>
                    <div slot="title">
                      <div class="baseInfo">
                        <a>{{ c_item.name }}</a
                        ><br />
                        <span>单价：￥{{ c_item.unitPrice }}</span
                        ><br />
                        <span>份数：{{ c_item.amount }}</span>
                      </div>
                      <div class="descInfo">
                        <template v-if="c_item.isPackage">
                          <span
                            v-for="(g_c_item, g_c_index) in c_item.menus"
                            :key="g_c_index"
                          >
                            {{ `${g_c_item.name}*${g_c_item.count}份` }}
                          </span>
                        </template>
                        <template v-else>
                          {{ !c_item.describe ? "暂无描述" : c_item.describe }}
                        </template>
                      </div>
                    </div>
                  </a-card-meta>
                </a-card>
              </a-list-item>
            </a-list>
          </div>
        </a-collapse-panel>
      </a-collapse>
    </div>

    <!-- 菜品发布页面 -->
    <menu-publish-drawer
      :drawerVisibleFlag="drawerVisibleFlag"
      :publishDate="currentDate"
      :publishMealType="publishMealType"
      :globalEditAble="globalEditAble"
      :publishListData="addPublishListData"
      @publishMenuSubmit="publishMenuSubmit"
      @close="publishMenuClose"
    ></menu-publish-drawer>
  </div>
</template>

<script>
import datePaginator from '@/components/date-paginator/date-paginator'
import menuPublishDrawer from './tpl/menu-publish-right-drawer'
import { getPublishMenu, getMenuPublishState } from '@/apis/publishMenu'
import { dateConvert } from "@/components/tools/date-convert"

const publishMenuList = [
  {
    title: '早餐',
    key: 'breakfast',
    type: 1,
    list: []
  },
  {
    title: '午餐',
    key: 'lunch',
    type: 2,
    list: []
  },
  {
    title: '晚餐',
    key: 'dinner',
    type: 3,
    list: []
  }
]

export default {
  data() {
    return {
      currentDate: dateConvert.convert(new Date(), 'yyyy-MM-dd'),
      today: dateConvert.convert(new Date(), 'yyyy-MM-dd'),
      // 发布菜品列表
      publishMenuList,
      listItemLoading: false,
      actionBtnShow: true,
      activeKey: ['breakfast', 'lunch', 'dinner'],
      // 菜品发布抽屉
      drawerVisibleFlag: false,
      // 发布菜品类型 早1 午2 晚3
      publishMealType: 1,
      //  发布前后  前false 后 true
      globalEditAble: false,
      // 发布list
      addPublishListData: [],
      // 发布状态
      publishhDateState: []
    }
  },
  methods: {
    // 图片样式
    getImgStyle(cItem, cIndex, item) {
      if (item.menus.length) {
        const len = item.menus.length > 4 ? 4 : item.menus.length;
        const multiple = Math.ceil(Math.sqrt(len));
        // 取余，表示第几列，除以向下取整，表示第几行-1
        const col = cIndex % multiple;
        const row = Math.floor(cIndex / multiple)

        return {
          position: 'absolute',
          top: (0 + row / multiple) * 100 + '%',
          left: (0 + col / multiple) * 100 + '%',
          width: (1 / multiple) * 100 + '%',
          height: (1 / multiple) * 100 + '%',
          padding: '1px'
        }
      }
    },
    // 获取菜品发布状态
    _getMenuPublishState() {
      getMenuPublishState({ date: this.currentDate }).then(res => {
        let result = res.data.attribute
        // console.log(result)
        this.publishhDateState = []
        result.forEach(item => {
          this.publishhDateState.push({
            date: item.date.substring(0, 10),
            isPublish: item.isPublish
          })
        })
      })
    },
    // 日期组件
    selectItemHandle(current) {
      this.currentDate = current.fullDate
      this._getMenuPublishState()
      this.getPublishMenuData()
    },
    // 显示发布菜品抽屉页面
    publishMenuShow(item, type) {
      this.publishMealType = item.type

      if (type === 'add') {
        this.addPublishListData = []
        this.globalEditAble = false
      } else if (type === 'edit') {
        this.globalEditAble = true

        const editObj = this.publishMenuList.filter((value) => {
          return value.type === this.publishMealType
        })[0]
        const data = editObj.list
        const returnData = []
        data.forEach((item, index) => {
          returnData.push({
            key: (index + 1).toString(),
            index: index + 1,
            id: item.id,
            name: item.name,
            img: item.imgUrl,
            price: item.unitPrice,
            desc: item.describe,
            amount: item.amount,
            isPackage: item.isPackage !== undefined,
            packageCode: item.code,
            publicMenuType: item.publicMenuType,
            isNew: false,
            editable: false
          })
        })
        this.addPublishListData = returnData
        //  = editObj.list
      }
      this.drawerVisibleFlag = true
    },
    // 关闭菜品发布抽屉页面
    publishMenuClose() {
      this.drawerVisibleFlag = false
      this.getPublishMenuData()
    },

    // 一键发布成功后续操作
    publishMenuSubmit() {
      this.drawerVisibleFlag = false
      this._getMenuPublishState()
      this.getPublishMenuData()
    },

    // 获取指定日期的发布菜单数据
    getPublishMenuData() {
      this.listItemLoading = true
      getPublishMenu({
        date: this.currentDate,
        isShow: true
      }).then((res) => {
        this.listItemLoading = false

        if (res.data.state === 1) {
          const result = res.data.attribute

          let i = 0
          for (let key in result) {
            let tempData = []
            result[key].packages.forEach(item => {
              let itemImgUrl = ''
              for (let i = 0; i < item.menus.length; i++) {
                if (item.menus[i].imgUrl) {
                  itemImgUrl = item.menus[i].imgUrl
                  break;
                }
              }
              tempData.push({
                amount: item.amount,
                describe: item.remark ? item.remark : '-',
                id: item.id,
                imgUrl: itemImgUrl,
                name: item.name,
                menus: item.menus,
                code: item.codeNumber,
                unitPrice: item.packagePrice,
                isPackage: true
              })
            })
            result[key].menus.forEach(item => {
              tempData.push(item)
            })
            this.publishMenuList[i].list = tempData
            i++
          }
        } else {
          this.$message.warning(res.message)
        }
      }, res => {
        this.listItemLoading = false
      })
    }
  },
  components: {
    datePaginator,
    menuPublishDrawer
  },
  created() {
    // 获取发布菜品的状态
    this._getMenuPublishState()
    // 获取当日发布的菜品
    this.getPublishMenuData()
    const currentTime = dateConvert.convert(new Date(), 'hh')
    if (currentTime <= 10) {
      this.activeKey = ['breakfast']
    } else if (currentTime > 10 && currentTime < 14) {
      this.activeKey = ['lunch']
    } else if (currentTime >= 14) {
      this.activeKey = ['dinner']
    }
  },
  watch: {
    currentDate: function (data) {
      if (new Date(data).getTime() < new Date(this.today).getTime()) {
        this.actionBtnShow = false
        this.activeKey = ['breakfast', 'lunch', 'dinner']
      } else {
        this.actionBtnShow = true
      }
    }
  }
}
</script>


<style lang="less" scoped>
.menu-publish-content {
  .menu-publish-item {
    margin: 10px 0;
  }
}

.slot-publish-href {
  text-decoration: none;
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 15px;
  height: 46px;
  line-height: 46px;
}

.ant-form-item-control-wrapper {
  width: 100% !important;
}
.itemImgContent {
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 100%;
  border-bottom: 1px solid #e8e8e8;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.publishMenuListContent /deep/.ant-card-hoverable:hover {
  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
  border-color: rgba(0, 0, 0, 0.09);
}
.publishMenuListContent /deep/ .ant-card-body {
  padding: 0;
}
.publishMenuListContent .ant-card-meta {
  height: 78px;
  overflow: hidden;
  line-height: 24px;
  .baseInfo {
    padding: 2px;
    margin-top: 0;
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    span {
      color: #999;
    }
  }
  .descInfo {
    padding: 2px 10px;
    width: 100%;
    height: 72px;
    margin-top: 72px;
    background-color: #eeeeee;
    color: #666;
    word-wrap: break-word;
    white-space: normal;
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
  }
  &:hover {
    .baseInfo {
      margin-top: -72px;
    }
    .descInfo {
      margin-top: -2px;
      transition: all 0.3s;
      -webkit-transition: all 0.3s;
    }
  }
}

.publishMenuListContent .ant-card-meta /deep/.ant-card-meta-title {
  font-size: 14px;
}

.ant-collapse-content-box .ant-spin-spinning {
  display: flex;
  justify-content: center;
}
</style>

